import React, { AnchorHTMLAttributes, ReactNode, useEffect, useState } from 'react';
const ROUTE_EVENT = 'pines-route-change';
export function navigate(to: string) {
  if (window.location.pathname === to) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return;
  }
  window.history.pushState({}, '', to);
  window.dispatchEvent(new Event(ROUTE_EVENT));
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}
export function useCurrentRoute() {
  const [path, setPath] = useState(() => window.location.pathname || '/');
  useEffect(() => {
    const handleChange = () => setPath(window.location.pathname || '/');
    window.addEventListener('popstate', handleChange);
    window.addEventListener(ROUTE_EVENT, handleChange);
    return () => {
      window.removeEventListener('popstate', handleChange);
      window.removeEventListener(ROUTE_EVENT, handleChange);
    };
  }, []);
  return path;
}
interface RouteLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: ReactNode;
}
export function RouteLink({
  to,
  children,
  onClick,
  ...props
}: RouteLinkProps) {
  return <a {...props} href={to} onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    navigate(to);
  }} data-id="element-400" data-mp="1e4js66oin5f1">
      {children}
    </a>;
}